export const MOBILE_MEDIA_QUERY = `(max-width: 500px)`;
export const defaultFooterSocialsModel = {
  isReplaced: false
};
export const ActionType = {
  SET_MOBILE: `SET_MOBILE`,
  SET_DEFAULT: `SET_DEFAULT`
};
